<template>
    <div class="import-user-modal">

        <div
            v-if="uploadingInProgress"
        >
            <p>{{ getVerbose('user_import_modal_uploading') }}</p>
        </div>
        <div
            v-else-if="importErrors.length > 0"
        >
            <p>{{ getVerbose('user_import_modal_importing_error') }}</p>
            <ul>
                <li v-for="error in importErrors">{{error}}</li>
            </ul>
        </div>

        <el-form
            v-else-if="listEmails.length > 0"
            ref="form"
            :model="form"
            :rules="rules"
            :label-position="windowWidth > 500 ? 'left' : 'top'"
            label-width="150px"
        >

            <el-form-item
                :label="getVerbose('user_import_form_label_users')"
            >
                <el-select
                    v-model="form.emails"
                    placeholder=""
                    multiple
                    style="width: 100%;"
                >
                    <el-option
                        v-for="email in listEmails"
                        :key="email"
                        :label="email"
                        :value="email"
                    >
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item
                :label="getVerbose('user_import_form_label_groups')"
            >
                <el-select
                    v-model="form.groups"
                    value-key="uid"
                    placeholder=""
                    multiple
                    filterable
                    style="width: 100%;"
                >
                    <el-option
                        v-for="item in groups"
                        :key="item.uid"
                        :label="item.name"
                        :value="item"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>

        <div
            v-else
            class="center"
        >
            <div class="user-import-container">
                <p class="help">
                    {{ getVerbose('user_import_help_text') }}
                </p>
                <el-upload
                    class="upload-file-emails-list"
                    drag
                    action=""
                    accept=".csv,.txt"
                    :before-upload="handleUploadEmailsList"
                    :show-file-list="false">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">{{ getVerbose('user_import_drop_file_text') }}<em>{{ getVerbose('user_import_drop_file_text_emphasized') }}</em></div>
                    <div class="el-upload__tip" slot="tip">{{ getVerbose('user_import_drop_file_tip') }}</div>
                </el-upload>
            </div>
        </div>

    </div>
</template>

<script>
import emailValidator from 'email-validator';
export default {

    components: {
    },
    props: {
        groups: {
            type: Array,
            required: true,
        },
        getVerbose: {
            type: Function,
            required: true
        },
        windowWidth: {
            type: Number,
            required: true,
        }
    },

    data (){
        return {
            form: {
                groups: [],
                emails: [],
            },
            rules: {
            },
            importDone: false,
            listEmails: [],
            uploadingInProgress: false,
            importErrors: [],
        };
    },

    methods: {
        handleUploadEmailsList(file){
            this.importEmailsList(file);
            return false;
        },
        async readFileLines(file){
            return new Promise((resolve, reject) => {
                if(!window.FileReader){
                    reject(
                        this.getVerbose('user_import_api_not_supported')
                    );
                }
                var reader = new FileReader();
                reader.onloadend = evt =>{
                    if (evt.target.readyState == FileReader.DONE) {
                        resolve(evt.target.result.split('\n').map(line => {
                            return line.replace(/[,; \r]/g, '');
                        }).filter(line => {
                            return line != '';
                        }));
                    }
                };
                reader.readAsText(file);
            });
        },
        async importEmailsList(file){
            this.uploadingInProgress = true;
            this.$set(this, 'listEmails', []);
            this.$set(this.form, 'emails', []);
            this.$set(this, 'importErrors', []);
            try{
                let emails = await this.readFileLines(file);
                // Set (remove duplicates) of lowerCased emails
                emails = Array.from(new Set(emails.map(email => email.toLowerCase())));

                for(let email of emails){
                    if(!emailValidator.validate(email)){
                        this.importErrors.push(`${email} ${this.getVerbose('user_import_email_not_valid')}`);
                    }
                    else{
                        this.listEmails.push(email);
                        this.form.emails.push(email);
                    }
                }
            }
            catch(error){
                this.importErrors.push(error);
            }
            this.uploadingInProgress = false;
        },

    },
};
</script>

<style lang="scss">
.import-user-modal{
    .center{
        display: flex;
        justify-content: center;
        text-align: center;

        .el-upload__input{
            display: none !important;
        }
        .user-import-container {
            width: 100%;
            .el-upload {
                width: 100%;
                @media (min-width: 500px) {
                    width: 50%;
                }
                .el-upload-dragger {
                    width: 100%;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// node_modules/fundation-app-vuejs/src/components/usersManagement/user/import-user-modal.vue